import type { Gutter } from 'antd/lib/grid/row';

export const GRID_SPACING_DEFAULT = [24, 24] as Gutter;
